import { UserIcon } from "lucide-react";
import { buildApiUrl } from "../../../lib/utils";

export type UserCardProps = {
  imageUrl?: string;
  fullName: string;
  email?: string;
};

const UserCard: React.FC<UserCardProps> = ({ imageUrl, fullName, email }) => {
  return (
    <div className="flex items-center space-x-3">
      {imageUrl ? (
        <img
          src={buildApiUrl(imageUrl)}
          alt={`${fullName}`}
          className="w-[30px] h-[30px] rounded-full object-cover border border-gray-300 shadow-sm"
        />
      ) : (
        <div className="w-[30px] h-[30px] rounded-full bg-gray-200 flex items-center justify-center border border-gray-300 shadow-sm p-1">
          <UserIcon className="w-full h-full text-hColor" />
        </div>
      )}
      <div className="flex flex-col">
        <span className="text-hColor capitalize">{fullName}</span>
        <span className="text-hColor text-sm">{email}</span>
      </div>
    </div>
  );
};

export default UserCard;
